import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { useState } from "react";
import BatchSetting from "./BatchSetting";
import BatchReport from "./BatchReport";
const BatchScheduling = () => {
  //State which maintain tab value
  const [tabValue, setTabValue] = useState("1");
  //Tab value change handler
  const tabValueChangeHandler = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <Box sx={{ background: "white", padding: "8px" }}>
      <Box sx={{ marginBottom: "12px" }}>
        <h4>Batch Configure</h4>
      </Box>
      <TabContext value={tabValue}>
        <Box
          sx={{
            borderColor: "divider",
            backgroundColor: "#eeeeee",
            marginLeft: "2%",
            display: "flex",
          }}
        >
          <TabList
            onChange={tabValueChangeHandler}
            aria-label="lab API tabs example"
            TabIndicatorProps={{ hidden: true }}
            sx={{
              "& button.Mui-selected": {
                backgroundColor: "#004a92",
                color: "white",
                // borderTopLeftRadius: "1rem",
                // borderTopRightRadius: "1rem",
                borderBottom: "none",
                minHeight: "0rem",
                height: "2.3rem",
              },
              "& div.MuiTabs-flexContainer": {
                flexWrap: "wrap",
              },
              "& button": {
                outline: "none",
                marginRight: "0.2rem",
                background: "#fafafa",
                color: "#7f7f7f",
                transition: "all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1)",
                borderBottom: "2px solid #AAAAAA",
                textTransform: "none",
                // borderTopLeftRadius: "1rem",
                // borderTopRightRadius: "1rem",
                backgroundColor: "#D7D7D7",
                minHeight: "0rem",
                height: "2.3rem",
              },
            }}
          >
            <Tab label="Batch Setting" value="1" />
            <Tab label="Batch Report" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <BatchSetting />
        </TabPanel>
        <TabPanel value="2">
          <BatchReport />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
export default BatchScheduling;
